import { Common } from './common';
import * as Encounter from './models/encounter';
import * as User from './models/user';
import * as Workflow from './models/workflow';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async assignMeNextEncounter(): Promise<
    | {
        success: true;
        encounter: Encounter.Encounter;
        workflow: Workflow.DisplayableWorkflow;
      }
    | { success: false; message: string }
  > {
    const url = this.common.constructPath(`/analyst/assignMeNextEncounter`);
    return this.common.postJSON(url, {});
  }

  async assignMeNextReview(): Promise<
    | {
        success: true;
        encounter: Encounter.Encounter;
        workflow: Workflow.DisplayableWorkflow;
      }
    | {
        success: false;
        message: string;
        workflow?: Workflow.DisplayableNoteWorkflow;
      }
  > {
    const url = this.common.constructPath(`/analyst/assignMeNextReview`);
    return this.common.postJSON(url, {});
  }

  async findUsers(): Promise<{ analysts: User.User[]; admins: User.User[] }> {
    const url = this.common.constructPath('/analyst/list');
    return this.common.getJSON(url);
  }
}
